define("shared/components/shared/modal", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{this.modalClass}} data-test-id="modal" ...attributes {{focus-on-destruct @focusOnDestructId}}>
    <div
      class="o--modalWrapper"
      {{focus-trap isActive=this.focusTrapActive focusTrapOptions=(hash allowOutsideClick=true)}}
      {{on-escape-key-up this.closeModal}}
    >
      {{#if this.backdrop}}
        <div
          aria-label={{t "shared_words.close"}}
          class="o--modal--close"
          data-test-id="modal-close"
          role="button"
          {{on "click" this.closeModal}}
        ></div>
      {{/if}}
      <div class="o--modalVer">
        <div class={{concat-classes "o--modalHor" @modalQaClass}}>
          <div
            aria-label={{or @customAriaLabel (t "shared_words.dialog")}}
            aria-modal="true"
            id="modal"
            role="dialog"
            tabindex="0"
          >
            {{yield
              (hash
                banner=(component "shared/modal/banner")
                card=(component
                  "shared/modal/section"
                  closable=this.closable
                  close=this.closeModal
                  closeButtonQaClass=@closeButtonQaClass
                )
                card-header=(component "shared/modal/header")
                card-body=(component "shared/ui/block" primaryClass="o--modalBody")
                card-footer=(component "shared/ui/block" primaryClass="o--modalFooter")
                close=this.closeModal
              )
            }}
          </div>
        </div>
      </div>
      {{#if @navigate}}
        <Shared::Modal::Navigation @navigate={{@navigate}} @navigationModel={{or @navigationModel "media"}} />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "tN4ijhAy",
    "block": "[[[11,0],[16,0,[30,0,[\"modalClass\"]]],[24,\"data-test-id\",\"modal\"],[17,1],[4,[38,0],[[30,2]],null],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--modalWrapper\"],[4,[38,1],null,[[\"isActive\",\"focusTrapOptions\"],[[30,0,[\"focusTrapActive\"]],[28,[37,2],null,[[\"allowOutsideClick\"],[true]]]]]],[4,[38,3],[[30,0,[\"closeModal\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"backdrop\"]],[[[1,\"      \"],[11,0],[16,\"aria-label\",[28,[37,5],[\"shared_words.close\"],null]],[24,0,\"o--modal--close\"],[24,\"data-test-id\",\"modal-close\"],[24,\"role\",\"button\"],[4,[38,6],[\"click\",[30,0,[\"closeModal\"]]],null],[12],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,0],[14,0,\"o--modalVer\"],[12],[1,\"\\n      \"],[10,0],[15,0,[28,[37,7],[\"o--modalHor\",[30,3]],null]],[12],[1,\"\\n        \"],[10,0],[15,\"aria-label\",[28,[37,8],[[30,4],[28,[37,5],[\"shared_words.dialog\"],null]],null]],[14,\"aria-modal\",\"true\"],[14,1,\"modal\"],[14,\"role\",\"dialog\"],[14,\"tabindex\",\"0\"],[12],[1,\"\\n          \"],[18,8,[[28,[37,2],null,[[\"banner\",\"card\",\"card-header\",\"card-body\",\"card-footer\",\"close\"],[[50,\"shared/modal/banner\",0,null,null],[50,\"shared/modal/section\",0,null,[[\"closable\",\"close\",\"closeButtonQaClass\"],[[30,0,[\"closable\"]],[30,0,[\"closeModal\"]],[30,5]]]],[50,\"shared/modal/header\",0,null,null],[50,\"shared/ui/block\",0,null,[[\"primaryClass\"],[\"o--modalBody\"]]],[50,\"shared/ui/block\",0,null,[[\"primaryClass\"],[\"o--modalFooter\"]]],[30,0,[\"closeModal\"]]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,6],[[[1,\"      \"],[8,[39,11],null,[[\"@navigate\",\"@navigationModel\"],[[30,6],[28,[37,8],[[30,7],\"media\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@focusOnDestructId\",\"@modalQaClass\",\"@customAriaLabel\",\"@closeButtonQaClass\",\"@navigate\",\"@navigationModel\",\"&default\"],false,[\"focus-on-destruct\",\"focus-trap\",\"hash\",\"on-escape-key-up\",\"if\",\"t\",\"on\",\"concat-classes\",\"or\",\"yield\",\"component\",\"shared/modal/navigation\"]]",
    "moduleName": "shared/components/shared/modal.hbs",
    "isStrictMode": false
  });
  let ModalComponent = _exports.default = (_class = class ModalComponent extends _component2.default {
    // Check if focus trap only targets modal elements
    get focusTrapActive() {
      return this.args.focusTrap ?? false;
    }

    // Defines whether or not the modal can be closed
    get closable() {
      if (this.args.inline) {
        return false;
      }
      return this.args.closable ?? true;
    }

    // Includes a modal close element in the background
    get backdrop() {
      if (this.args.inline) {
        return false;
      }
      return this.args.backdrop ?? true;
    }

    /**
     * @property modalClass
     * @type {String}
     * @default 'o--modalBg'
     */
    get modalClass() {
      const fallbackClass = !this.backdrop || this.args.inline ? 'o--modalBg--inner' : 'o--modalBg';
      return this.args.primaryClass ?? fallbackClass;
    }

    /**
     * Closes the modal if 'closable' and a valid 'close' function exists
     *
     * @method closeModal
     */
    closeModal() {
      if (this.closable && typeof this.args.close === 'function') {
        this.args.close();
      } else if (!this.closable && typeof this.args.onAttemptedClose === 'function') {
        this.args.onAttemptedClose();
      }
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ModalComponent);
});